import styled from "styled-components";
import { FlexDiv } from "components/common/styled";
import {
  getThemeColor,
  getStyle,
  H00,
  W_TEXT_LIGHT,
  W_TEXT_DARK,
} from "constants/colors";

export const SettingItem = styled(FlexDiv)`
  .setting-item-part {
    font-size: 14px;
    color: ${getStyle([W_TEXT_DARK, W_TEXT_LIGHT])};
    line-height: 16px;

    &:first-child {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .icon-tishi1 {
        font-size: 12px;
        margin-left: 4px;
      }
    }
  }
`;

export const SettingBody = styled.div`
  padding: 20px 0px 0px;

  ${SettingItem} {
    padding: 16px 0;
  }
`;

export const SettingLine = styled.div`
  width: 100%;
  padding: 0 10px;
  margin: 0px 0;
  box-sizing: border-box;
  height: 1px;
  background: var(--cointr-color-line2);
`;

export const SettingTitle = styled.div`
  color: ${getStyle(H00)};
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 36px;
  font-family: "Space Grotesk", "SpaceGrotesk", "Arial", "sans-serif";
`;
